import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { GetUserActivityListApi } from "../../../api/request/team/team.js";
import MySegmented from "../../../components/segmented/Segmented.jsx";
import SkeletonTable from "../../../components/table/SkeletonTable";
import activityColumn from "../../../columns/team/activity.js";
import organizerColumn from "../../../columns/team/organizer.js";

const ViewTeam = () => {
  const { id } = useParams();
  const [segmentedValue, setSegmentedValue] = useState("Activities");
  const [data, setData] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const tableColumn = {
    Activities: activityColumn,
    Organizers: organizerColumn,
    Tasks: organizerColumn,
  };

  const GetUserActivityList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetUserActivityListApi({ id });
      if (data?.status) setData(data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getFilteredData = (type) => {
    if (type === "Activities") {
      return data?.user_activity?.map((item) => {
        return {
          ...item,
          date: item?.created_at ? moment(item?.created_at).format("lll") : "",
        };
      });
    } else if (type === "Organizers") {
      return data?.organizer?.map((item) => {
        return {
          ...item,
          organizer: (
            <div className="capitalize">
              {item?.organizer?.organizer_name_slug}
            </div>
          ),
        };
      });
    } else if (type === "Tasks") {
      return data?.bussiness_task?.map((item) => {
        return {
          ...item,
          organizer: (
            <div className="capitalize">
              {item?.organizer?.organizer_name_slug}
            </div>
          ),
        };
      });
    } else if (type === "Permissions") {
      return data?.emp_tasks?.[0]?.task_master;
    } else {
      return [];
    }
  };

  useEffect(() => {
    GetUserActivityList();
  }, []);

  useEffect(() => {
    const list = getFilteredData(segmentedValue);
    setFilteredData(list);
  }, [segmentedValue, data]);

  return (
    <div>
      <MySegmented
        options={["Activities", "Organizers", "Tasks", "Permissions"]}
        value={segmentedValue}
        setValue={setSegmentedValue}
      />

      <div className="border-2 rounded-xl my-5">
        <div className="flex justify-between mx-5 mt-5">
          <p className=" font-semibold text-2xl">{segmentedValue}</p>
        </div>
        <div className="my-6">
          {segmentedValue === "Permissions" ? (
            <div className="flex gap-5 px-5">
              {filteredData?.map((item, index) => (
                <div
                  key={`permission_${index}`}
                  className="p-3 font-medium border-2 rounded-md text-secondaryLight1"
                >
                  <div className="mx-auto flex items-center justify-center size-9 rounded-md bg-primaryLight">
                    <p className="font-bold text-primary text-lg">{index+1}</p>
                  </div>
                  <p className="text-center text-black mt-3">{item?.name}</p>
                </div>
              ))}
            </div>
          ) : (
            <SkeletonTable
              columns={tableColumn[segmentedValue]}
              data={filteredData}
              isLoading={isLoading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewTeam;
